import http from "@/utils/http";

export default {
	uploadImage: (data) => {
		return http({ url: '/api/admin/v1/basic/uploadImage', data }).then(r => r);
	},
	uploadImageFile: (data) => {
		return http({ url: '/api/admin/v1/basic/uploadImageFile', data, files: true }).then(r => r);
	},
	removeImage: (data) => {
		return http({ url: '/api/admin/v1/basic/removeImage', data }).then(r => r);
	},
	exportExcel: (data) => {
		return http({ url: '/api/admin/v1/basic/exportExcel', data }).then(r => r);
	},
	getArea: (data) => {
		return http({ url: '/api/admin/v1/region/tree', data }).then(r => r);
	},
	getCityArea: (data) => {
		return http({ url: '/api/admin/v1/region/cityTree', data }).then(r => r);
	},
}
